// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  name: 'kyoshi-prod',
  version: 'Error: no tags found (local or remote).',
  production: false,
  bucketName: 'kyoshi',
  databaseUrl: { supabase: 'https://betlqfqaejtbzsklrgkv.supabase.co', middleware: '' },
  posCloud: {
    apiURL: 'https://kyoshi.menucat.de/api',
  },
  editEnabled: 'false',
  defaultLanguage: 'DE',
  databaseAnonKey: { supabase: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJldGxxZnFhZWp0Ynpza2xyZ2t2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODM1MTYzNjQsImV4cCI6MjA5OTA5MjM2NH0.4nQeq0dFMpay5e7eaZ6cGo-NMBRTkPOLYw6PcmRwFxs', middleware: '' },
  sentryDSN: '',
  posthogKey: 'phc_m3dOImc0jDJ5IzfKERikqSr4Nshq8XFVWV6DJKgYzhu',
  posthogHost: 'https://eu.i.posthog.com',
  posthogProxyHost: 'https://t.unauorder.com',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
